.card-item {
  border-radius: 0.8rem;
  width: 100%;

  @media only screen and (min-width: 427px) {
    background: var(--color-grayscale-charleston);
  }
}

.card-title {
  height: 4rem;
  padding: 1.2rem 0;
  overflow: hidden;
  border-radius: 0.8rem 0.8rem 0 0;

  color: var(--color-grayscale-white);
  font-size: 1.4rem;
  font-weight: 600;
  line-height: normal;

  @media only screen and (min-width: 427px) {
    background: var(--color-grayscale-shark);
    padding: 1.2rem 1.6rem;
  }
}

.subtitle {
  color: var(--color-grayscale-manatee);
  font-size: 1.4rem;
  font-weight: 400;
  line-height: 2.2rem;
}

.content {
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  padding: 1.6rem 0;

  color: var(--color-grayscale-white);
  font-size: 1.4rem;
  font-weight: 400;
  line-height: 2.2rem;

  @media only screen and (min-width: 427px) {
    padding: 1.6rem;
  }
}

.footer {
  width: 100%;
  padding: 1.6rem 0;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media only screen and (min-width: 427px) {
    border-top: 1px solid var(--color-grayscale-tuna);
    padding: 1.6rem;
  }
}
